import { signIn, signOut } from '@/services/firebase';
import { useCallback } from 'react';

const useFirebase = () => {
  const login = useCallback(async (token: string) => {
    await signIn(token);
  }, []);

  const logout = useCallback(async (wasSessionCreated: boolean = true) => {
    await signOut(wasSessionCreated);
  }, []);

  return { login, logout };
};

export default useFirebase;
